export const URL_USERPORTAL = 'https://ntv-user-portal-preprod.prod.rtl.de/'

export const URL_LOGIN = URL_USERPORTAL + 'login'
export const URL_OFFERS = URL_USERPORTAL + 'offers'
export const URL_REGISTER = URL_USERPORTAL + 'register'
export const URL_BRIDGE = 'https://apps.n-tv.de/stat/auth/bridge.html'

// DPV
// toDo: iframe and redirect als apps subdomain
// export const URL_DPV_BRIDGE = 'https://apps.n-tv.de/stat/account/handler.html';
export const URL_DPV_BRIDGE = 'https://www.n-tv.de/auth/handler.html'
export const URL_DPV_REGISTER = 'https://sso.guj.de/ntv_web/user/signup'
export const URL_DPV_OFFERS = 'https://shop.n-tv.de/de_DE/ntv-pur-abo/4000019.html'
export const URL_DPV_MANAGE = 'https://sso.guj.de/ntv_web/user/account/overview'
